/**
 * Additional Phrases - Round 2
 * 额外短语 - 第二轮（完成剩余230个短语）
 * Target: Complete 1000 phrases total
 */

import { Phrase } from './phrases-types';

export const additionalPhrasesRound2: Phrase[] = [
  // ==================== 小学基础短语补充（100个）====================

  // 家庭生活（25个）
  {
    id: 'add2-family-1',
    phrase: 'come home',
    meaning: '回家',
    example: 'I come home at 5 pm.',
    exampleTranslation: '我下午5点回家。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-2',
    phrase: 'go home',
    meaning: '回家',
    example: 'Let\'s go home together.',
    exampleTranslation: '我们一起回家吧。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-3',
    phrase: 'at home',
    meaning: '在家',
    example: 'I\'m at home now.',
    exampleTranslation: '我现在在家。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-4',
    phrase: 'help mom',
    meaning: '帮妈妈',
    example: 'I help mom cook dinner.',
    exampleTranslation: '我帮妈妈做晚饭。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-5',
    phrase: 'help dad',
    meaning: '帮爸爸',
    example: 'I help dad wash the car.',
    exampleTranslation: '我帮爸爸洗车。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-6',
    phrase: 'family dinner',
    meaning: '家庭晚餐',
    example: 'We have family dinner together.',
    exampleTranslation: '我们一起吃家庭晚餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-7',
    phrase: 'watch together',
    meaning: '一起看',
    example: 'We watch TV together.',
    exampleTranslation: '我们一起看电视。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-8',
    phrase: 'eat together',
    meaning: '一起吃',
    example: 'Let\'s eat together.',
    exampleTranslation: '我们一起吃吧。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-9',
    phrase: 'play together',
    meaning: '一起玩',
    example: 'Can we play together?',
    exampleTranslation: '我们可以一起玩吗？',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-10',
    phrase: 'study together',
    meaning: '一起学习',
    example: 'Let\'s study together.',
    exampleTranslation: '我们一起学习吧。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-11',
    phrase: 'family photo',
    meaning: '全家福',
    example: 'This is our family photo.',
    exampleTranslation: '这是我们的全家福。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-12',
    phrase: 'family trip',
    meaning: '家庭旅行',
    example: 'We had a family trip.',
    exampleTranslation: '我们有一次家庭旅行。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-13',
    phrase: 'clean the room',
    meaning: '打扫房间',
    example: 'I clean my room every week.',
    exampleTranslation: '我每周打扫房间。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-14',
    phrase: 'tidy up',
    meaning: '整理',
    example: 'Tidy up your toys.',
    exampleTranslation: '整理你的玩具。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-15',
    phrase: 'do housework',
    meaning: '做家务',
    example: 'I help do housework.',
    exampleTranslation: '我帮忙做家务。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-16',
    phrase: 'take a nap',
    meaning: '午睡',
    example: 'I take a nap after lunch.',
    exampleTranslation: '午饭后我午睡。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-17',
    phrase: 'go to sleep',
    meaning: '去睡觉',
    example: 'It\'s time to go to sleep.',
    exampleTranslation: '该睡觉了。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-18',
    phrase: 'tell a story',
    meaning: '讲故事',
    example: 'Mom tells me a story.',
    exampleTranslation: '妈妈给我讲故事。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-19',
    phrase: 'read a book',
    meaning: '读书',
    example: 'I read a book before bed.',
    exampleTranslation: '我睡前读书。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-family-20',
    phrase: 'write a letter',
    meaning: '写信',
    example: 'I want to write a letter.',
    exampleTranslation: '我想写一封信。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-21',
    phrase: 'call grandma',
    meaning: '给奶奶打电话',
    example: 'I call grandma every week.',
    exampleTranslation: '我每周给奶奶打电话。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-22',
    phrase: 'visit relatives',
    meaning: '拜访亲戚',
    example: 'We visit relatives on holidays.',
    exampleTranslation: '我们节假日拜访亲戚。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-23',
    phrase: 'have a picnic',
    meaning: '野餐',
    example: 'Let\'s have a picnic!',
    exampleTranslation: '我们去野餐吧！',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-24',
    phrase: 'in the garden',
    meaning: '在花园里',
    example: 'I play in the garden.',
    exampleTranslation: '我在花园里玩。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-family-25',
    phrase: 'water the flowers',
    meaning: '浇花',
    example: 'I water the flowers every day.',
    exampleTranslation: '我每天浇花。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },

  // 学校生活（25个）
  {
    id: 'add2-school-1',
    phrase: 'in the classroom',
    meaning: '在教室里',
    example: 'We are in the classroom.',
    exampleTranslation: '我们在教室里。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-2',
    phrase: 'in the library',
    meaning: '在图书馆',
    example: 'I read books in the library.',
    exampleTranslation: '我在图书馆读书。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-3',
    phrase: 'on the playground',
    meaning: '在操场上',
    example: 'We play on the playground.',
    exampleTranslation: '我们在操场上玩。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-4',
    phrase: 'have a class',
    meaning: '上课',
    example: 'We have a class at 8 am.',
    exampleTranslation: '我们早上8点上课。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-5',
    phrase: 'finish class',
    meaning: '下课',
    example: 'We finish class at 4 pm.',
    exampleTranslation: '我们下午4点下课。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-6',
    phrase: 'have a break',
    meaning: '休息',
    example: 'Let\'s have a break.',
    exampleTranslation: '我们休息一下吧。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-7',
    phrase: 'go to the bathroom',
    meaning: '去洗手间',
    example: 'Can I go to the bathroom?',
    exampleTranslation: '我可以去洗手间吗？',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-8',
    phrase: 'hand in homework',
    meaning: '交作业',
    example: 'Don\'t forget to hand in homework.',
    exampleTranslation: '别忘了交作业。',
    category: 'school',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-9',
    phrase: 'check homework',
    meaning: '检查作业',
    example: 'The teacher checks homework.',
    exampleTranslation: '老师检查作业。',
    category: 'school',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-school-10',
    phrase: 'have a test',
    meaning: '考试',
    example: 'We will have a test tomorrow.',
    exampleTranslation: '我们明天要考试。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-11',
    phrase: 'get good grades',
    meaning: '取得好成绩',
    example: 'I want to get good grades.',
    exampleTranslation: '我想取得好成绩。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-12',
    phrase: 'work hard',
    meaning: '努力学习',
    example: 'You need to work hard.',
    exampleTranslation: '你需要努力学习。',
    category: 'school',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-13',
    phrase: 'pay attention',
    meaning: '注意听讲',
    example: 'Please pay attention.',
    exampleTranslation: '请注意听讲。',
    category: 'school',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-14',
    phrase: 'sit down',
    meaning: '坐下',
    example: 'Please sit down.',
    exampleTranslation: '请坐下。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-15',
    phrase: 'stand up',
    meaning: '起立',
    example: 'Stand up, please.',
    exampleTranslation: '请起立。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-16',
    phrase: 'open the book',
    meaning: '打开书',
    example: 'Open your book to page 10.',
    exampleTranslation: '打开书翻到第10页。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-17',
    phrase: 'close the book',
    meaning: '合上书',
    example: 'Close your book.',
    exampleTranslation: '合上书。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-school-18',
    phrase: 'read the text',
    meaning: '读课文',
    example: 'Read the text aloud.',
    exampleTranslation: '大声朗读课文。',
    category: 'school',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-19',
    phrase: 'answer the question',
    meaning: '回答问题',
    example: 'Who can answer the question?',
    exampleTranslation: '谁能回答这个问题？',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-20',
    phrase: 'write on the board',
    meaning: '在黑板上写',
    example: 'The teacher writes on the board.',
    exampleTranslation: '老师在黑板上写字。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-school-21',
    phrase: 'have lunch at school',
    meaning: '在学校吃午餐',
    example: 'I have lunch at school.',
    exampleTranslation: '我在学校吃午餐。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-22',
    phrase: 'after school',
    meaning: '放学后',
    example: 'I play soccer after school.',
    exampleTranslation: '放学后我踢足球。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-school-23',
    phrase: 'before class',
    meaning: '上课前',
    example: 'Review your notes before class.',
    exampleTranslation: '上课前复习笔记。',
    category: 'school',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-school-24',
    phrase: 'in the hallway',
    meaning: '在走廊里',
    example: 'Don\'t run in the hallway.',
    exampleTranslation: '不要在走廊里跑。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-school-25',
    phrase: 'school bus',
    meaning: '校车',
    example: 'I take the school bus.',
    exampleTranslation: '我坐校车。',
    category: 'school',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },

  // 饮食相关（25个）
  {
    id: 'add2-food-1',
    phrase: 'have breakfast',
    meaning: '吃早餐',
    example: 'I have breakfast at 7 am.',
    exampleTranslation: '我早上7点吃早餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-2',
    phrase: 'have lunch',
    meaning: '吃午餐',
    example: 'Let\'s have lunch together.',
    exampleTranslation: '我们一起吃午餐吧。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-3',
    phrase: 'have dinner',
    meaning: '吃晚餐',
    example: 'We have dinner at 6 pm.',
    exampleTranslation: '我们下午6点吃晚餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-4',
    phrase: 'cook dinner',
    meaning: '做晚饭',
    example: 'Mom is cooking dinner.',
    exampleTranslation: '妈妈在做晚饭。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-5',
    phrase: 'make breakfast',
    meaning: '做早餐',
    example: 'I make breakfast for my family.',
    exampleTranslation: '我给家人做早餐。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-6',
    phrase: 'eat out',
    meaning: '外出就餐',
    example: 'Let\'s eat out tonight.',
    exampleTranslation: '我们今晚出去吃吧。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-7',
    phrase: 'order food',
    meaning: '点餐',
    example: 'I want to order food.',
    exampleTranslation: '我想点餐。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-8',
    phrase: 'my favorite food',
    meaning: '我最喜欢的食物',
    example: 'Pizza is my favorite food.',
    exampleTranslation: '披萨是我最喜欢的食物。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-9',
    phrase: 'something to drink',
    meaning: '喝的东西',
    example: 'I want something to drink.',
    exampleTranslation: '我想喝点东西。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-10',
    phrase: 'something to eat',
    meaning: '吃的东西',
    example: 'Do you want something to eat?',
    exampleTranslation: '你想吃点东西吗？',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-11',
    phrase: 'drink water',
    meaning: '喝水',
    example: 'Drink more water every day.',
    exampleTranslation: '每天多喝水。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-12',
    phrase: 'drink milk',
    meaning: '喝牛奶',
    example: 'I drink milk every morning.',
    exampleTranslation: '我每天早上喝牛奶。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-13',
    phrase: 'eat an apple',
    meaning: '吃苹果',
    example: 'I eat an apple every day.',
    exampleTranslation: '我每天吃一个苹果。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-14',
    phrase: 'tastes good',
    meaning: '味道好',
    example: 'This cake tastes good!',
    exampleTranslation: '这个蛋糕味道很好！',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-15',
    phrase: 'tastes bad',
    meaning: '味道不好',
    example: 'The medicine tastes bad.',
    exampleTranslation: '这药味道不好。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-16',
    phrase: 'sweet tooth',
    meaning: '爱吃甜食',
    example: 'I have a sweet tooth.',
    exampleTranslation: '我爱吃甜食。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },
  {
    id: 'add2-food-17',
    phrase: 'on the table',
    meaning: '在桌子上',
    example: 'The food is on the table.',
    exampleTranslation: '食物在桌子上。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-18',
    phrase: 'in the fridge',
    meaning: '在冰箱里',
    example: 'The milk is in the fridge.',
    exampleTranslation: '牛奶在冰箱里。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-19',
    phrase: 'at the restaurant',
    meaning: '在餐馆',
    example: 'We are at the restaurant.',
    exampleTranslation: '我们在餐馆。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-20',
    phrase: 'fast food',
    meaning: '快餐',
    example: 'I like fast food.',
    exampleTranslation: '我喜欢快餐。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-21',
    phrase: 'healthy food',
    meaning: '健康食品',
    example: 'Vegetables are healthy food.',
    exampleTranslation: '蔬菜是健康食品。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-food-22',
    phrase: 'junk food',
    meaning: '垃圾食品',
    example: 'Don\'t eat too much junk food.',
    exampleTranslation: '不要吃太多垃圾食品。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-23',
    phrase: 'set the table',
    meaning: '摆桌子',
    example: 'Help me set the table.',
    exampleTranslation: '帮我摆桌子。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-24',
    phrase: 'clear the table',
    meaning: '收拾桌子',
    example: 'Please clear the table.',
    exampleTranslation: '请收拾桌子。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-food-25',
    phrase: 'wash the dishes',
    meaning: '洗碗',
    example: 'I help wash the dishes.',
    exampleTranslation: '我帮忙洗碗。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },

  // 天气季节（25个）
  {
    id: 'add2-weather-1',
    phrase: 'nice weather',
    meaning: '好天气',
    example: 'What nice weather!',
    exampleTranslation: '多好的天气啊！',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-2',
    phrase: 'bad weather',
    meaning: '坏天气',
    example: 'Today is bad weather.',
    exampleTranslation: '今天天气不好。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-3',
    phrase: 'sunny day',
    meaning: '晴天',
    example: 'It\'s a sunny day.',
    exampleTranslation: '今天是晴天。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-4',
    phrase: 'rainy day',
    meaning: '下雨天',
    example: 'It\'s a rainy day.',
    exampleTranslation: '今天是下雨天。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-5',
    phrase: 'cloudy day',
    meaning: '多云天',
    example: 'It\'s a cloudy day.',
    exampleTranslation: '今天多云。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-6',
    phrase: 'snowy day',
    meaning: '下雪天',
    example: 'It\'s a snowy day.',
    exampleTranslation: '今天下雪。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-7',
    phrase: 'windy day',
    meaning: '有风的天',
    example: 'It\'s a windy day.',
    exampleTranslation: '今天有风。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-8',
    phrase: 'hot day',
    meaning: '热天',
    example: 'It\'s a hot day.',
    exampleTranslation: '今天很热。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-9',
    phrase: 'cold day',
    meaning: '冷天',
    example: 'It\'s a cold day.',
    exampleTranslation: '今天很冷。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-10',
    phrase: 'warm day',
    meaning: '温暖的一天',
    example: 'It\'s a warm day.',
    exampleTranslation: '今天很温暖。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-11',
    phrase: 'cool day',
    meaning: '凉爽的一天',
    example: 'It\'s a cool day.',
    exampleTranslation: '今天很凉爽。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-12',
    phrase: 'in spring',
    meaning: '在春天',
    example: 'Flowers bloom in spring.',
    exampleTranslation: '春天花儿开放。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-13',
    phrase: 'in summer',
    meaning: '在夏天',
    example: 'We swim in summer.',
    exampleTranslation: '夏天我们游泳。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-14',
    phrase: 'in autumn',
    meaning: '在秋天',
    example: 'Leaves fall in autumn.',
    exampleTranslation: '秋天树叶落下。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-15',
    phrase: 'in winter',
    meaning: '在冬天',
    example: 'It snows in winter.',
    exampleTranslation: '冬天下雪。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-16',
    phrase: 'put on a coat',
    meaning: '穿上外套',
    example: 'Put on a coat. It\'s cold.',
    exampleTranslation: '穿上外套，天冷了。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-17',
    phrase: 'take off the coat',
    meaning: '脱下外套',
    example: 'It\'s hot. Take off your coat.',
    exampleTranslation: '热了，脱下外套吧。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-18',
    phrase: 'wear a hat',
    meaning: '戴帽子',
    example: 'Wear a hat in summer.',
    exampleTranslation: '夏天戴帽子。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-19',
    phrase: 'use an umbrella',
    meaning: '用雨伞',
    example: 'Use an umbrella on rainy days.',
    exampleTranslation: '下雨天用雨伞。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-20',
    phrase: 'wear sunglasses',
    meaning: '戴太阳镜',
    example: 'Wear sunglasses on sunny days.',
    exampleTranslation: '晴天戴太阳镜。',
    category: 'weather',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-21',
    phrase: 'wear sunscreen',
    meaning: '涂防晒霜',
    example: 'Wear sunscreen at the beach.',
    exampleTranslation: '在沙滩上涂防晒霜。',
    category: 'weather',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'low'
  },
  {
    id: 'add2-weather-22',
    phrase: 'weather report',
    meaning: '天气预报',
    example: 'Let\'s check the weather report.',
    exampleTranslation: '我们看看天气预报。',
    category: 'weather',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-23',
    phrase: 'the sun is shining',
    meaning: '阳光明媚',
    example: 'The sun is shining brightly.',
    exampleTranslation: '阳光明媚。',
    category: 'weather',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'add2-weather-24',
    phrase: 'it is raining',
    meaning: '正在下雨',
    example: 'It is raining outside.',
    exampleTranslation: '外面正在下雨。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'add2-weather-25',
    phrase: 'it is snowing',
    meaning: '正在下雪',
    example: 'It is snowing heavily.',
    exampleTranslation: '雪下得很大。',
    category: 'weather',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 初中进阶短语（130个）====================

  // 情感与态度（30个）
  {
    id: 'add2-feeling-1',
    phrase: 'feel like doing',
    meaning: '想要做某事',
    example: 'I feel like eating ice cream.',
    exampleTranslation: '我想吃冰淇淋。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-2',
    phrase: 'would like to',
    meaning: '想要',
    example: 'I would like to go with you.',
    exampleTranslation: '我想和你一起去。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-3',
    phrase: 'feel sorry for',
    meaning: '为...感到难过',
    example: 'I feel sorry for him.',
    exampleTranslation: '我为他感到难过。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-4',
    phrase: 'feel excited about',
    meaning: '对...感到兴奋',
    example: 'I feel excited about the trip.',
    exampleTranslation: '我对这次旅行感到兴奋。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-5',
    phrase: 'make friends with',
    meaning: '与...交朋友',
    example: 'I want to make friends with you.',
    exampleTranslation: '我想和你交朋友。',
    category: 'social',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-6',
    phrase: 'get along with',
    meaning: '与...相处',
    example: 'I get along well with my classmates.',
    exampleTranslation: '我和同学相处得很好。',
    category: 'social',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-7',
    phrase: 'be strict with',
    meaning: '对...严格',
    example: 'My teacher is strict with us.',
    exampleTranslation: '我的老师对我们很严格。',
    category: 'social',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-8',
    phrase: 'be angry about',
    meaning: '对...生气',
    example: 'He is angry about the news.',
    exampleTranslation: '他对这个消息很生气。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-9',
    phrase: 'be pleased with',
    meaning: '对...满意',
    example: 'I\'m pleased with your work.',
    exampleTranslation: '我对你的工作满意。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-10',
    phrase: 'be satisfied with',
    meaning: '对...满意',
    example: 'Are you satisfied with the result?',
    exampleTranslation: '你对结果满意吗？',
    category: 'emotions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-11',
    phrase: 'be disappointed with',
    meaning: '对...失望',
    example: 'I\'m disappointed with the movie.',
    exampleTranslation: '我对这部电影很失望。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-12',
    phrase: 'be popular with',
    meaning: '受...欢迎',
    example: 'He is popular with students.',
    exampleTranslation: '他很受学生欢迎。',
    category: 'social',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-13',
    phrase: 'be familiar with',
    meaning: '熟悉',
    example: 'I\'m familiar with this city.',
    exampleTranslation: '我熟悉这个城市。',
    category: 'social',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-14',
    phrase: 'be similar to',
    meaning: '与...相似',
    example: 'Your answer is similar to mine.',
    exampleTranslation: '你的答案与我的相似。',
    category: 'social',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-15',
    phrase: 'be different from',
    meaning: '与...不同',
    example: 'My opinion is different from yours.',
    exampleTranslation: '我的观点与你的不同。',
    category: 'social',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-16',
    phrase: 'be responsible for',
    meaning: '对...负责',
    example: 'Who is responsible for this project?',
    exampleTranslation: '谁负责这个项目？',
    category: 'social',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-17',
    phrase: 'be famous for',
    meaning: '因...而出名',
    example: 'Paris is famous for the Eiffel Tower.',
    exampleTranslation: '巴黎因埃菲尔铁塔而出名。',
    category: 'social',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-18',
    phrase: 'be late for',
    meaning: '迟到',
    example: 'Don\'t be late for school.',
    exampleTranslation: '上学别迟到。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-19',
    phrase: 'be ready for',
    meaning: '准备好',
    example: 'Are you ready for the test?',
    exampleTranslation: '你准备好考试了吗？',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-20',
    phrase: 'be afraid to',
    meaning: '害怕做某事',
    example: 'Don\'t be afraid to ask questions.',
    exampleTranslation: '不要害怕提问。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-21',
    phrase: 'be sure to',
    meaning: '一定会',
    example: 'Be sure to come on time.',
    exampleTranslation: '一定要准时来。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-22',
    phrase: 'be certain to',
    meaning: '肯定会',
    example: 'He is certain to win.',
    exampleTranslation: '他肯定会赢。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-23',
    phrase: 'be likely to',
    meaning: '可能',
    example: 'It\'s likely to rain today.',
    exampleTranslation: '今天可能会下雨。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-24',
    phrase: 'be supposed to',
    meaning: '应该',
    example: 'You are supposed to finish it today.',
    exampleTranslation: '你应该今天完成它。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-25',
    phrase: 'be used to doing',
    meaning: '习惯于做某事',
    example: 'I\'m used to getting up early.',
    exampleTranslation: '我习惯早起。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-26',
    phrase: 'get used to',
    meaning: '习惯于',
    example: 'You will get used to it.',
    exampleTranslation: '你会习惯的。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-27',
    phrase: 'be worth doing',
    meaning: '值得做',
    example: 'This book is worth reading.',
    exampleTranslation: '这本书值得一读。',
    category: 'opinions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-28',
    phrase: 'be busy doing',
    meaning: '忙于做某事',
    example: 'She is busy cooking dinner.',
    exampleTranslation: '她正忙着做晚饭。',
    category: 'daily_life',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-feeling-29',
    phrase: 'have trouble doing',
    meaning: '做某事有困难',
    example: 'I have trouble understanding this.',
    exampleTranslation: '我理解这个有困难。',
    category: 'academic',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-feeling-30',
    phrase: 'have fun doing',
    meaning: '做某事很开心',
    example: 'We have fun playing games.',
    exampleTranslation: '我们玩游戏很开心。',
    category: 'daily_life',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },

  // 建议、请求与回应（30个）
  {
    id: 'add2-request-1',
    phrase: 'why don\'t you',
    meaning: '你为什么不',
    example: 'Why don\'t you take a rest?',
    exampleTranslation: '你为什么不休息一下？',
    category: 'suggestions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-2',
    phrase: 'why not',
    meaning: '为什么不',
    example: 'Why not go now?',
    exampleTranslation: '为什么不现在去？',
    category: 'suggestions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-3',
    phrase: 'how about',
    meaning: '...怎么样',
    example: 'How about a cup of tea?',
    exampleTranslation: '来杯茶怎么样？',
    category: 'suggestions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-4',
    phrase: 'what about',
    meaning: '...怎么样',
    example: 'What about going to the cinema?',
    exampleTranslation: '去看电影怎么样？',
    category: 'suggestions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-5',
    phrase: 'you\'d better',
    meaning: '你最好',
    example: 'You\'d better study hard.',
    exampleTranslation: '你最好努力学习。',
    category: 'suggestions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-6',
    phrase: 'you should',
    meaning: '你应该',
    example: 'You should see a doctor.',
    exampleTranslation: '你应该看医生。',
    category: 'suggestions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-7',
    phrase: 'you ought to',
    meaning: '你应该',
    example: 'You ought to help him.',
    exampleTranslation: '你应该帮助他。',
    category: 'suggestions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-8',
    phrase: 'shall we',
    meaning: '我们要...吗',
    example: 'Shall we go now?',
    exampleTranslation: '我们要现在走吗？',
    category: 'suggestions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-9',
    phrase: 'let\'s',
    meaning: '让我们',
    example: 'Let\'s have a break.',
    exampleTranslation: '我们休息一下吧。',
    category: 'suggestions',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-10',
    phrase: 'could you please',
    meaning: '请你...好吗',
    example: 'Could you please help me?',
    exampleTranslation: '请你帮我好吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-11',
    phrase: 'would you mind',
    meaning: '你介意...吗',
    example: 'Would you mind closing the door?',
    exampleTranslation: '你介意关门吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-12',
    phrase: 'do you mind',
    meaning: '你介意...吗',
    example: 'Do you mind my smoking?',
    exampleTranslation: '你介意我吸烟吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-13',
    phrase: 'I wonder if',
    meaning: '我想知道是否',
    example: 'I wonder if you can help me.',
    exampleTranslation: '我想知道你是否能帮我。',
    category: 'requests',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-14',
    phrase: 'may I',
    meaning: '我可以...吗',
    example: 'May I come in?',
    exampleTranslation: '我可以进来吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-15',
    phrase: 'can I',
    meaning: '我可以...吗',
    example: 'Can I borrow your pen?',
    exampleTranslation: '我可以借你的笔吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-16',
    phrase: 'could I',
    meaning: '我可以...吗（更礼貌）',
    example: 'Could I use your phone?',
    exampleTranslation: '我可以用你的电话吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-17',
    phrase: 'I\'d like to',
    meaning: '我想要',
    example: 'I\'d like to make a suggestion.',
    exampleTranslation: '我想提个建议。',
    category: 'requests',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-18',
    phrase: 'I want to',
    meaning: '我想要',
    example: 'I want to ask a question.',
    exampleTranslation: '我想问一个问题。',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-19',
    phrase: 'I hope to',
    meaning: '我希望',
    example: 'I hope to see you again.',
    exampleTranslation: '我希望再见到你。',
    category: 'requests',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-20',
    phrase: 'I wish to',
    meaning: '我希望',
    example: 'I wish to speak to the manager.',
    exampleTranslation: '我想和经理说话。',
    category: 'requests',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-21',
    phrase: 'no problem',
    meaning: '没问题',
    example: 'Can you help? - No problem!',
    exampleTranslation: '你能帮忙吗？- 没问题！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-22',
    phrase: 'no way',
    meaning: '没门',
    example: 'No way! I won\'t do it.',
    exampleTranslation: '没门！我不会做的。',
    category: 'responses',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-23',
    phrase: 'of course',
    meaning: '当然',
    example: 'Can I go? - Of course!',
    exampleTranslation: '我可以去吗？- 当然！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-24',
    phrase: 'certainly',
    meaning: '当然',
    example: 'Certainly, I can help you.',
    exampleTranslation: '当然，我可以帮你。',
    category: 'responses',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-25',
    phrase: 'sure thing',
    meaning: '没问题',
    example: 'Sure thing, I\'ll be there.',
    exampleTranslation: '没问题，我会到那儿。',
    category: 'responses',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-26',
    phrase: 'absolutely',
    meaning: '绝对',
    example: 'Absolutely! I agree.',
    exampleTranslation: '绝对！我同意。',
    category: 'responses',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-27',
    phrase: 'definitely',
    meaning: '肯定',
    example: 'Definitely, I\'ll come.',
    exampleTranslation: '肯定，我会来的。',
    category: 'responses',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-28',
    phrase: 'I\'d love to',
    meaning: '我很乐意',
    example: 'Would you like to come? - I\'d love to.',
    exampleTranslation: '你想来吗？- 我很乐意。',
    category: 'responses',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-request-29',
    phrase: 'I\'d be happy to',
    meaning: '我很乐意',
    example: 'I\'d be happy to help.',
    exampleTranslation: '我很乐意帮忙。',
    category: 'responses',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-request-30',
    phrase: 'with pleasure',
    meaning: '很乐意',
    example: 'With pleasure, let me help.',
    exampleTranslation: '很乐意，让我帮忙。',
    category: 'responses',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },

  // 其他常用短语（70个）
  {
    id: 'add2-other-1',
    phrase: 'first of all',
    meaning: '首先',
    example: 'First of all, let me introduce myself.',
    exampleTranslation: '首先，让我自我介绍一下。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-2',
    phrase: 'above all',
    meaning: '最重要的是',
    example: 'Above all, be honest.',
    exampleTranslation: '最重要的是，要诚实。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-3',
    phrase: 'most importantly',
    meaning: '最重要的是',
    example: 'Most importantly, don\'t give up.',
    exampleTranslation: '最重要的是，不要放弃。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-4',
    phrase: 'for example',
    meaning: '例如',
    example: 'For example, apples are healthy.',
    exampleTranslation: '例如，苹果很健康。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-5',
    phrase: 'for instance',
    meaning: '例如',
    example: 'For instance, English is useful.',
    exampleTranslation: '例如，英语很有用。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-6',
    phrase: 'such as',
    meaning: '例如',
    example: 'I like fruits such as apples.',
    exampleTranslation: '我喜欢水果，例如苹果。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '5',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-7',
    phrase: 'according to',
    meaning: '根据',
    example: 'According to the report, it\'s true.',
    exampleTranslation: '根据报告，这是真的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-8',
    phrase: 'based on',
    meaning: '基于',
    example: 'Based on my experience, I agree.',
    exampleTranslation: '基于我的经验，我同意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-9',
    phrase: 'as a result',
    meaning: '结果',
    example: 'He worked hard. As a result, he passed.',
    exampleTranslation: '他努力了，结果他通过了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-10',
    phrase: 'as a consequence',
    meaning: '结果',
    example: 'It rained. As a consequence, we stayed home.',
    exampleTranslation: '下雨了，结果我们待在家。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-11',
    phrase: 'in addition',
    meaning: '此外',
    example: 'In addition, I have another idea.',
    exampleTranslation: '此外，我还有另一个想法。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-12',
    phrase: 'furthermore',
    meaning: '而且',
    example: 'Furthermore, it\'s important.',
    exampleTranslation: '而且，这很重要。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-13',
    phrase: 'moreover',
    meaning: '而且',
    example: 'Moreover, it\'s cheap.',
    exampleTranslation: '而且，它很便宜。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-14',
    phrase: 'besides',
    meaning: '此外',
    example: 'Besides, I\'m tired.',
    exampleTranslation: '此外，我累了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-15',
    phrase: 'what\'s more',
    meaning: '而且',
    example: 'What\'s more, it\'s fun.',
    exampleTranslation: '而且，这很有趣。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-16',
    phrase: 'on the contrary',
    meaning: '相反',
    example: 'On the contrary, I disagree.',
    exampleTranslation: '相反，我不同意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-17',
    phrase: 'on the other hand',
    meaning: '另一方面',
    example: 'On the other hand, it\'s expensive.',
    exampleTranslation: '另一方面，它很贵。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-18',
    phrase: 'in contrast',
    meaning: '相反',
    example: 'In contrast, she likes it.',
    exampleTranslation: '相反，她喜欢它。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-19',
    phrase: 'however',
    meaning: '然而',
    example: 'However, I don\'t agree.',
    exampleTranslation: '然而，我不同意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-20',
    phrase: 'nevertheless',
    meaning: '尽管如此',
    example: 'Nevertheless, we should try.',
    exampleTranslation: '尽管如此，我们应该尝试。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-21',
    phrase: 'nonetheless',
    meaning: '尽管如此',
    example: 'Nonetheless, it\'s worth trying.',
    exampleTranslation: '尽管如此，值得一试。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    frequency: 'low'
  },
  {
    id: 'add2-other-22',
    phrase: 'therefore',
    meaning: '因此',
    example: 'Therefore, we must act now.',
    exampleTranslation: '因此，我们必须现在行动。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-23',
    phrase: 'thus',
    meaning: '因此',
    example: 'Thus, we can solve it.',
    exampleTranslation: '因此，我们可以解决它。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-24',
    phrase: 'hence',
    meaning: '因此',
    example: 'Hence, we need to work harder.',
    exampleTranslation: '因此，我们需要更加努力。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    frequency: 'low'
  },
  {
    id: 'add2-other-25',
    phrase: 'meanwhile',
    meaning: '同时',
    example: 'Meanwhile, let\'s wait here.',
    exampleTranslation: '同时，我们在这里等吧。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-26',
    phrase: 'in short',
    meaning: '简而言之',
    example: 'In short, I agree with you.',
    exampleTranslation: '简而言之，我同意你。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-27',
    phrase: 'in brief',
    meaning: '简而言之',
    example: 'In brief, the plan is good.',
    exampleTranslation: '简而言之，计划不错。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-28',
    phrase: 'to sum up',
    meaning: '总结',
    example: 'To sum up, it\'s a success.',
    exampleTranslation: '总结一下，这是一个成功。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-29',
    phrase: 'in conclusion',
    meaning: '结论',
    example: 'In conclusion, we won.',
    exampleTranslation: '结论是，我们赢了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-30',
    phrase: 'to conclude',
    meaning: '结论',
    example: 'To conclude, thank you all.',
    exampleTranslation: '最后，谢谢大家。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-31',
    phrase: 'by the way',
    meaning: '顺便说一下',
    example: 'By the way, did you see my bag?',
    exampleTranslation: '顺便说一下，你看到我的包了吗？',
    category: 'expressions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-32',
    phrase: 'in a word',
    meaning: '总之',
    example: 'In a word, yes.',
    exampleTranslation: '总之，是的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-33',
    phrase: 'in other words',
    meaning: '换句话说',
    example: 'In other words, you don\'t want to go.',
    exampleTranslation: '换句话说，你不想去。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-34',
    phrase: 'that is to say',
    meaning: '也就是说',
    example: 'That is to say, we need to start over.',
    exampleTranslation: '也就是说，我们需要重新开始。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-35',
    phrase: 'to be exact',
    meaning: '准确地说',
    example: 'To be exact, it\'s 10 km away.',
    exampleTranslation: '准确地说，它在10公里外。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-36',
    phrase: 'to tell the truth',
    meaning: '说实话',
    example: 'To tell the truth, I don\'t know.',
    exampleTranslation: '说实话，我不知道。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-37',
    phrase: 'believe it or not',
    meaning: '信不信由你',
    example: 'Believe it or not, I won the prize.',
    exampleTranslation: '信不信由你，我获奖了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-38',
    phrase: 'as far as I know',
    meaning: '据我所知',
    example: 'As far as I know, he is honest.',
    exampleTranslation: '据我所知，他很诚实。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-39',
    phrase: 'as far as I\'m concerned',
    meaning: '就我而言',
    example: 'As far as I\'m concerned, I agree.',
    exampleTranslation: '就我而言，我同意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-40',
    phrase: 'in my opinion',
    meaning: '在我看来',
    example: 'In my opinion, it\'s wrong.',
    exampleTranslation: '在我看来，这是错的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-41',
    phrase: 'from my point of view',
    meaning: '从我的角度来看',
    example: 'From my point of view, it\'s good.',
    exampleTranslation: '从我的角度来看，这很好。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-42',
    phrase: 'personally',
    meaning: '个人认为',
    example: 'Personally, I don\'t like it.',
    exampleTranslation: '个人认为，我不喜欢它。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-43',
    phrase: 'to some extent',
    meaning: '在某种程度上',
    example: 'I agree to some extent.',
    exampleTranslation: '我在某种程度上同意。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-44',
    phrase: 'to a certain degree',
    meaning: '在一定程度上',
    example: 'It\'s true to a certain degree.',
    exampleTranslation: '这在一定程度上是真的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-45',
    phrase: 'more or less',
    meaning: '或多或少',
    example: 'It\'s more or less the same.',
    exampleTranslation: '这或多或少是一样的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-46',
    phrase: 'at least',
    meaning: '至少',
    example: 'At least, try your best.',
    exampleTranslation: '至少，尽力而为。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-47',
    phrase: 'at most',
    meaning: '最多',
    example: 'It costs 10 dollars at most.',
    exampleTranslation: '最多花10美元。',
    category: 'expressions',
    difficulty: 'easy',
    grade: '6',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-48',
    phrase: 'at best',
    meaning: '最多',
    example: 'At best, we can finish tomorrow.',
    exampleTranslation: '最多我们明天能完成。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'low'
  },
  {
    id: 'add2-other-49',
    phrase: 'at worst',
    meaning: '最坏情况下',
    example: 'At worst, we\'ll fail.',
    exampleTranslation: '最坏情况下，我们会失败。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'low'
  },
  {
    id: 'add2-other-50',
    phrase: 'no doubt',
    meaning: '毫无疑问',
    example: 'No doubt, he will come.',
    exampleTranslation: '毫无疑问，他会来。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-51',
    phrase: 'without doubt',
    meaning: '毫无疑问',
    example: 'Without doubt, it\'s the best.',
    exampleTranslation: '毫无疑问，这是最好的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-52',
    phrase: 'there is no doubt that',
    meaning: '毫无疑问',
    example: 'There is no doubt that he is honest.',
    exampleTranslation: '毫无疑问他是诚实的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-53',
    phrase: 'it goes without saying',
    meaning: '不言而喻',
    example: 'It goes without saying that health is important.',
    exampleTranslation: '不言而喻，健康很重要。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-54',
    phrase: 'it is obvious that',
    meaning: '很明显',
    example: 'It is obvious that he is lying.',
    exampleTranslation: '很明显他在撒谎。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-55',
    phrase: 'it is clear that',
    meaning: '很清楚',
    example: 'It is clear that we need help.',
    exampleTranslation: '很清楚我们需要帮助。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-56',
    phrase: 'it is well known that',
    meaning: '众所周知',
    example: 'It is well known that smoking is harmful.',
    exampleTranslation: '众所周知吸烟有害。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-57',
    phrase: 'as we all know',
    meaning: '众所周知',
    example: 'As we all know, exercise is good.',
    exampleTranslation: '众所周知，运动有益。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-58',
    phrase: 'it is said that',
    meaning: '据说',
    example: 'It is said that he is rich.',
    exampleTranslation: '据说他很富有。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'add2-other-59',
    phrase: 'it is reported that',
    meaning: '据报道',
    example: 'It is reported that it will rain.',
    exampleTranslation: '据报道会下雨。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-60',
    phrase: 'it is believed that',
    meaning: '人们相信',
    example: 'It is believed that he can win.',
    exampleTranslation: '人们相信他能赢。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-61',
    phrase: 'it is expected that',
    meaning: '预计',
    example: 'It is expected that prices will rise.',
    exampleTranslation: '预计价格会上涨。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-62',
    phrase: 'it is estimated that',
    meaning: '据估计',
    example: 'It is estimated that it takes 2 hours.',
    exampleTranslation: '据估计需要2小时。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-63',
    phrase: 'it is suggested that',
    meaning: '有人建议',
    example: 'It is suggested that we leave early.',
    exampleTranslation: '有人建议我们早点离开。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-64',
    phrase: 'it is thought that',
    meaning: '人们认为',
    example: 'It is thought that he is honest.',
    exampleTranslation: '人们认为他是诚实的。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-65',
    phrase: 'it is considered that',
    meaning: '人们认为',
    example: 'It is considered that he is smart.',
    exampleTranslation: '人们认为他很聪明。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-66',
    phrase: 'what\'s more important',
    meaning: '更重要的是',
    example: 'What\'s more important, be happy.',
    exampleTranslation: '更重要的是，要快乐。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-67',
    phrase: 'what\'s worse',
    meaning: '更糟糕的是',
    example: 'What\'s worse, it started to rain.',
    exampleTranslation: '更糟糕的是，开始下雨了。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-68',
    phrase: 'to make matters worse',
    meaning: '更糟糕的是',
    example: 'To make matters worse, I lost my key.',
    exampleTranslation: '更糟糕的是，我丢了钥匙。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    frequency: 'low'
  },
  {
    id: 'add2-other-69',
    phrase: 'last but not least',
    meaning: '最后但同样重要',
    example: 'Last but not least, thank you.',
    exampleTranslation: '最后但同样重要的是，谢谢你。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'add2-other-70',
    phrase: 'needless to say',
    meaning: '不用说',
    example: 'Needless to say, be careful.',
    exampleTranslation: '不用说，要小心。',
    category: 'expressions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    frequency: 'medium'
  }
];
